import React, { useState, useEffect } from "react";
import { SearchOutlined } from "@ant-design/icons";
import SearchLg from "@untitled-ui/icons-react/build/esm/SearchLg"
import { ConfigProvider, Input, Select } from "antd";
import appStatic from "../config/appStatic";
import { useNavigate } from "react-router-dom";
const Search = Input;

export default function MenuSearchBar(props) {

  const navigate = useNavigate()
  const [taskIDData, setTaskIDData] = useState([]);

  useEffect(() => {
    TaskID();
  }, []);

  function TaskID() {
    let templateData = appStatic.screenIdData
    let templateArray = []

    templateData.map((element) => {
      templateArray.push({
        label: element?.screenid,
        value: element?.screenid.toLowerCase()
      });
    });

    setTaskIDData(templateArray);
  }

  const handleChange = (value) => {
    navigate(`/${value}`)
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          colorBgContainer: "#F7F9FC",
          colorBorder: props.colorBorder,
          colorTextPlaceholder: props.colorTextPlaceholder,
        },
        components: { Search: { activeBorderColor: "#0C0C0C" } },
      }}
    >
      <Search
        placeholder="Task ID"
        allowClear
        // onSearch={onSearch}
        style={{
          width: "80%",
          marginTop: 25,
          marginBottom: 25,
          marginLeft: 20,
          border: "1px"
        }}
        prefix={
          <SearchLg style={{ color: props.colorTextPlaceholder, width: "1em" }} />
        }
        options={taskIDData}
        onChange={handleChange}
      />
    </ConfigProvider>
  );
}
